var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"size":_vm.size}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }